import * as React from 'react'
import { createGlobalStyle, StyleSheetManager } from 'styled-components'
import NotificationPreview from '../../components/NotificationPreview'
import { ConversationMessage } from '../../../types'

const GlobalStyle = createGlobalStyle`
  html, body {
    margin: 0;
    padding: 0;
    background: transparent;
  }

  body {
    display: flex;
    align-items: flex-end;
  }
`

interface IProps {
  head?: HTMLHeadElement
  message: ConversationMessage | null
  onClick: (message: ConversationMessage) => void
  onClose: () => void
  onHeightChange?: (height: number) => void
}

class Notification extends React.Component<IProps> {
  componentDidMount() {
    const { head } = this.props
    if (head) this.injectHeadElements(head)
  }

  injectHeadElements(head: HTMLHeadElement) {
    const preconnectGoogle = document.createElement('link')
    preconnectGoogle.rel = 'preconnect'
    preconnectGoogle.href = 'https://fonts.googleapis.com'
    head.appendChild(preconnectGoogle)

    const preconnectGstatic = document.createElement('link')
    preconnectGstatic.rel = 'preconnect'
    preconnectGstatic.href = 'https://fonts.gstatic.com'
    preconnectGstatic.crossOrigin = 'anonymous'
    head.appendChild(preconnectGstatic)

    const fontLink = document.createElement('link')
    fontLink.href = 'https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&family=Roboto:ital,wght@0,100..900;1,100..900&display=swap'
    fontLink.rel = 'stylesheet'
    head.appendChild(fontLink)

    const viewportMeta = document.createElement('meta')
    viewportMeta.name = 'viewport'
    viewportMeta.content = 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no'
    head.appendChild(viewportMeta)
  }

  render() {
    const { head, message, onClick, onClose, onHeightChange } = this.props

    if (!head) return null

    return (
      <StyleSheetManager target={head}>
        <>
          <GlobalStyle />
          <NotificationPreview
            message={message}
            onClick={onClick}
            onClose={onClose}
            onHeightChange={onHeightChange}
          />
        </>
      </StyleSheetManager>
    )
  }
}

export default Notification
